"use strict";
/*
 * @ai-prompt-initial: Create the new rich domain model for PlayerRound.
 * This file should be created at `functions-model/src/match/playerRound.model.ts`.
 * It must define the `PlayerRound` interface and the `createPlayerRound`
 * constructor function, encapsulating all state-reading logic.
 * It should not contain any state mutation logic.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPlayerRound = void 0;
const baseRoles_1 = require("../players/roles/baseRoles");
/**
 * Creates a rich PlayerRound object from a raw PlayerRoundState.
 *
 * @param {PlayerRoundState} state The raw state of the player in the round.
 * @returns {PlayerRound} A new PlayerRound object with navigation functions.
 */
const createPlayerRound = (state) => {
    return {
        getUnderlyingState: () => state,
        getLineupIndex: () => state.lineupIndex,
        isDiscarded: () => state.discarded === true,
        getPlayerDetails: () => state.playerDetails,
        getMatchModifiers: () => state.matchModifiers,
        getCurrentLevel: () => state.currentLevel,
        getInitialLevel: () => state.initialLevel,
        getRoundEvents: () => state.roundEvents,
        getId: () => state.playerDetails.id,
        getRoll: () => state.roll,
        isGoalie: () => state.playerDetails.baseRole === baseRoles_1.BaseRoles.GOAL_KEEPER,
        getStatBlock: () => state.playerDetails.combinedBonus.statBlock,
        getPlayerTraits: () => state.playerDetails.combinedBonus.playerTraits,
        getNationId: () => state.playerDetails.national.nationId,
        getRaceId: () => state.playerDetails.raceId,
        getPreferredOpponent: () => state.playerDetails.combinedBonus.preferredOpponent,
        hasTrait: (trait) => state.playerDetails.combinedBonus.playerTraits.includes(trait)
    };
};
exports.createPlayerRound = createPlayerRound;
